export enum Feature {
  Stock = 'stock_screen',
  PriceForecast = 'price_forecast_screen',
  DemandForecast = 'demand_forecast_screen',
  Planning = 'planning_screen',
  ElectricityPurchasing = 'electricity_purchasing',
  ControlOperatorScreen = 'control_room_operator_view',
  PlanningComments = 'planning_comments',
  OperatorViewExactElectricityPrices = 'operator_view_exact_electricity_prices',
  OperatorViewColorCodedElectricityPrices = 'operator_view_color_coded_electricity_prices',
  ShutdownAvailability = 'shutdown_availability',
  CostAvoidance = 'cost_avoidance',
  UpmAssetsAndStorages = 'upm_assets_and_storages',
  // TODO: to be removed once standardOperationTimes are new fully implemented
  NewStandardOperationTimes = 'newStandardOperationTimes',
  JanusShowPssTab = 'janus_show_pss_tab',
  EnableOptimizedAssets = 'enable_optimized_assets'
}

export enum PlantStructureTabs {
  General = 'general',
  Configuration = 'configuration',
  CrusherFlow = 'crusherFlow',
  Layout = 'layout',
  HeatZones = 'heatZones',
  DrillingZones = 'drillingZones',
  Sensors = 'sensors',
  Kpis = 'kpis',
  GrindingCircuits = 'grindingCircuits',
  BaseLoad = 'baseLoad',
  OperationModes = 'operationModes',
  StandardTimes = 'standardTimes',
  Optimizer = 'optimizer',
  Connection = 'connection',
  Admin = 'admin'
}
